import { LuBan, LuHeart, LuShield } from 'react-icons/lu';
import styles from '../styles.module.scss';

const ITEMS = [
    {
        icon: <LuShield />,
        title: '完全匿名',
        desc: '個人情報の入力は\n一切不要です',
    },
    {
        icon: <LuBan />,
        title: '営業電話なし',
        desc: '査定後の営業連絡は\nありません',
    },
    {
        icon: <LuHeart />,
        title: 'ずっと無料',
        desc: '何度でも無料で\nご利用いただけます',
    },
];

export const ReassureSection = () => {
    return (
        <section className={styles.reassureSection}>
            {ITEMS.map((item) => (
                <div key={item.title} className={styles.reassureCard}>
                    <div className={styles.reassureIcon}>{item.icon}</div>
                    <span className={styles.reassureTitle}>{item.title}</span>
                    <p className={styles.reassureDesc}>{item.desc}</p>
                </div>
            ))}
        </section>
    );
};
